export interface ArticleI {
  id?: number;
  titre: string;
  slug: string;
  intro?: string;
  media?: MediaI;
  media_id?: number | null;
  contenu?: string;
  statut?: StatutE;
  categorie?: CatI;
  categorie_id?: number | null;
  auteur?: UserI;
  auteur_id?: number | null;
  creation?: string;
  exergue?: boolean | number;
  subject?: number;
}
export interface CatI {
  id?: number;
  titre: string;
  slug: string;
  description?: string;
  articles?: Array<ArticleI>;
  creation?: string;
  auteur_id?: number;
  statut: string;
}
export interface LienI {
  id?: number;
  titre: string;
  href: string;
}
export interface MediaI {
  id?: number;
  url: string;
  nom: string;
  largeur?: number;
  hauteur?: number;
  mime?: string;
  poids?: number;
  auteur?: UserI;
  auteur_id?: number;
}
export interface DateI {
  id?: 1;
  date: string;
  type: TypeActionE;
}
export interface MotI {
  id?: number;
  mot: string;
  parent?: number;
  children?: Array<MotI>;
}
export interface ContribI {
  id?: number;
  contributor: string;
}
export interface CreateurI {
  id?: number;
  creator: string;
}
export interface PersonneI {
  id?: number;
  personne: string;
}
export interface NoticeI {
  id?: number;
  title: string;
  creator?: Array<number>;
  subject?: Array<number>;
  description: string;
  publisher: string;
  relation?: string;
  date?: number;
  type: string;
  format: string;
  identifier: string;
  source: string;
  language: string;
  coverage?: number;
  rights: string;
  media?: MediaI;
  creation?: string;
  modification?: string;
  localisation?: any;
  statut: string;
  auteur?: UserI;
  // themes?: Array<number>;
  motscles?: Array<number>;
  contributor?: Array<number>;
  personnes?: Array<number>;
  accordAttestation: number;
  accordConditions: number;
  accordRgpd: number;
  media_id?: number;
  auteur_id?: number;
  periode?: number;
}
export interface LieuI {
  id?: number;
  lieu: string;
}
export interface PeriodeI {
  id?: number;
  periode: string;
}
export interface ThemeI {
  id?: number;
  theme?: string;
  parent?: number;
  children?: Array<ThemeI>;
}
export interface UserI {
  id?: number;
  email: string;
  password?: string;
  roles?: Array<string>;
  nom?: string;
  prenom?: string;
  adresse?: string;
  accord?: boolean;
  token?: string;
  statut?: string;
  reset?: string;
}
export interface DroitI {
  licence: string;
  lien: string;
  legende: string
}
export enum StatutE {
  publie = 'publie',
  brouillon = 'brouillon',
  archive = 'archive',
  supprime = 'supprime',
  tout = 'tout'
}
export enum TypeActionE {
  cree = 'cree',
  maj = "maj",
  del = 'del'
}
export enum RolesE {
  ROLE_ADMIN = 'Administrateur',
  ROLE_USER = 'Utilisateur',
  ROLE_ANONYME = 'Anonyme'
}
export class Notice implements NoticeI {
  title = '';
  creator = [];
  subject = [];
  description = '';
  publisher = 'Ville de Blagnac';
  relation = '';
  date = 0;
  type = '';
  format = '';
  identifier = '';
  source = '';
  language = 'fr_FR';
  coverage = 0;
  rights = '';
  media_id = 0;
  creation = '';
  modification = new Date().toISOString();
  localisation = { adresse: '', latitude: 0, longitude: 0 };
  statut = StatutE.brouillon;
  auteur_id?: 0;
  motscles = [];
  // themes = [];
  contributor = [];
  personnes = [];
  periode = 0;
  accordAttestation = 1;
  accordConditions = 1;
  accordRgpd = 1;
};
export class Personne implements PersonneI {
  contributor = '';
  personne = '';
  creator = '';
}
export interface LocalI {
  adresse: string; latitude?: number; longitude?: number;
}